// src/components/ProjectCard.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ExternalLink } from 'lucide-react';

const ProjectCard = ({
  title,
  description,
  image,        // <— NUEVO: ruta de imagen de fondo (en /public/images/…)
  features = [],
  onClick,
  index = 0
}) => {
  return (
    <motion.div
      className="relative rounded-3xl overflow-hidden shadow-xl group cursor-pointer h-[440px] flex items-end"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.2, duration: 0.6 }}
      whileHover={{ y: -8, scale: 1.01 }}
      onClick={onClick}
    >
      {/* Imagen de fondo */}
      <img
        src={image}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        loading="lazy"
      />

      {/* Overlay para legibilidad */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/35 to-black/10"></div>

      {/* Icono de link arriba derecha (decorativo) */}
      <motion.div
        className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        initial={{ scale: 0.8 }}
        whileHover={{ scale: 1 }}
      >
        <ExternalLink className="w-5 h-5 text-white/80" />
      </motion.div>

      {/* Contenido */}
      <div className="relative z-10 p-7 w-full">
        <h3 className="text-2xl font-bold text-white mb-2 drop-shadow-sm">{title}</h3>
        <p className="text-white/90 leading-relaxed mb-5 max-w-[60ch]">{description}</p>

        {/* Bullets opcionales */}
        {features?.length > 0 && (
          <ul className="space-y-1.5 mb-6">
            {features.slice(0, 3).map((f, i) => (
              <li key={i} className="flex items-center gap-2 text-white/90">
                <span className="w-1.5 h-1.5 rounded-full bg-white/80"></span>
                <span className="text-sm">{f}</span>
              </li>
            ))}
          </ul>
        )}

        {/* Botones “vidriados”: dejan ver la foto detrás del texto */}
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="px-5 py-2.5 rounded-xl border border-white/40 bg-white/15 text-white font-semibold backdrop-blur-[2px] hover:bg-white/25 transition"
          >
            Explorar
          </button>

          <button
            type="button"
            className="px-5 py-2.5 rounded-xl border border-white/30 bg-white/10 text-white/95 backdrop-blur-[2px] hover:bg-white/20 transition flex items-center gap-2"
          >
            Ver más…
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;